import { WebSocketReceiveMessage } from './web-socket-receive-message';

export class WebSocketReceiveData extends WebSocketReceiveMessage {}
